import React from 'react';
import moment, {Moment} from "moment/moment";
import DateRangeDescription from "./DateRangeDescription";


interface ConsignmentFromToDateTimeProps {
    fromDateTime: string,    // ISO String
    toDateTime: string,      // ISO String
    revisedDateTime?: string, // ISO String
    defaultDate?: Moment // PropTypes.instanceOf(moment)
}

const ConsignmentFromToDateTime = (
    {
        fromDateTime,
        toDateTime,
        revisedDateTime,
        defaultDate
    }: ConsignmentFromToDateTimeProps
) => {

    if (!fromDateTime || !toDateTime) {
        return null;
    }

    const momentFrom = moment(fromDateTime);
    const momentTo = revisedDateTime ? moment(revisedDateTime) : moment(toDateTime);
    const isDefaultDate = defaultDate && momentFrom.isSame(momentTo, 'day') && momentFrom.isSame(defaultDate, 'day');
    const fromTime = momentFrom.format('HH:mm');
    let formattedTime = null;
    if (isDefaultDate && fromTime === momentTo.format('HH:mm')) {
        if (fromTime === "00:00") {
            formattedTime = "All Day";
        } else {
            formattedTime = fromTime;
        }
    } else if (isDefaultDate) {
        formattedTime = fromTime + " - " + momentTo.format("HH:mm");
    }
    const stringToDateTime = revisedDateTime ? revisedDateTime : toDateTime;
    return (
        <span>
            {isDefaultDate ? formattedTime :
                <DateRangeDescription fromISOTimestamp={fromDateTime}
                                      toISOTimestamp={stringToDateTime}
                />}
        </span>
    );
};

export default ConsignmentFromToDateTime;
